import { ErrorSettings, InputSettings } from '../../../types/template-types';

export enum ErrorType {
  Warning = 0,
  Error = 1
}

export const VALIDATION_ADDITION_ADD_BUTTON = 'Add';
export const VALIDATION_ADDITION_EDIT_BUTTON = 'Edit';
export const GENERIC_FIELD_NAME = 'FIELD';

export enum CriteriaType {
  None = 0,
  Email = 1,
  Exactly = 2,
  Contains = 3,
  NotContains = 4,
  Length = 5,
  GreaterThan = 6,
  GreaterThanOrEqualTo = 7,
  LessThan = 8,
  LessThanOrEqualTo = 9,
  EqualTo = 10,
  NotEqualTo = 11,
  Between = 12,
  NotBetween = 13
}

export enum InputSelectionType {
  None = 0,
  SetValue = 1,
  PickField = 2
}
export const InputTypeOptions = [
  { value: InputSelectionType.SetValue, text: 'Set value' },
  { value: InputSelectionType.PickField, text: 'Pick field' }
];

export const TextCriteriaOptions = [
  { value: CriteriaType.Email, text: 'is email' },
  { value: CriteriaType.Exactly, text: 'is exactly' },
  { value: CriteriaType.Contains, text: 'contains' },
  { value: CriteriaType.NotContains, text: 'does not contain' },
  { value: CriteriaType.Length, text: 'length is' }
];

export const NumberCriteriaOptions = [
  { value: CriteriaType.GreaterThan, text: 'is greater than' },
  { value: CriteriaType.GreaterThanOrEqualTo, text: 'is greater than or equal to' },
  { value: CriteriaType.LessThan, text: 'is less than' },
  { value: CriteriaType.LessThanOrEqualTo, text: 'is less than or equal to' },
  { value: CriteriaType.EqualTo, text: 'is equal to' },
  { value: CriteriaType.NotEqualTo, text: 'is not equal to' },
  { value: CriteriaType.Between, text: 'is between' },
  { value: CriteriaType.NotBetween, text: 'is not between' }
];

export type InputValues = {
  inputValueOne: string;
  inputValueTwo: string;
};

export type ValidationSettingsState = {
  id: string;
  validationNumber: number;
  buttonOn: boolean;
  criteria: CriteriaType;
  displayMessage: string;
  inputValues: InputSettings[];
  resetInputTypeSelection: boolean;
  showSettingsConfig: boolean;
};

export const INITIAL_VALIDATION_SETTINGS_STATE: ValidationSettingsState = {
  id: '',
  validationNumber: 0,
  buttonOn: false,
  criteria: CriteriaType.None,
  displayMessage: '',
  inputValues: [{ inputValue: '', inputValueSelectionType: InputSelectionType.None }],
  resetInputTypeSelection: false,
  showSettingsConfig: false
};

export const INITIAL_INPUT_VALUES: InputSettings = {
  inputValue: '',
  inputValueSelectionType: InputSelectionType.None
};

export type InvalidFieldValue = {
  errorSettings: ErrorSettings;
  fieldId: string;
  fieldName: string;
};
